import styled from 'styled-components';
import { Button, QuoteRow } from '@insly/qmt-reactjs-ui-lib';
import { DefaultIcon, SMALL_SCREEN_WIDTH } from 'styles/common';

export const ControlsButton = styled(Button)<{ fullWidth?: boolean }>`
  height: 40px;
  min-width: 200px;
  &.qmt-ui-button--l {
    font-size: 14px;
    padding: ${({ fullWidth }) => fullWidth ? 0 : null};
    flex: ${({ fullWidth }) => fullWidth ? 1 : null};
    min-width: ${({ fullWidth }) => fullWidth ? 'auto' : null};
  }
`;

export const IssuingButton = styled(ControlsButton)`
  &.issuing-button {
    min-width: auto;
    width: 148px;
    padding: 10px 10px;
  }

  @media (max-width: ${SMALL_SCREEN_WIDTH}) {
    height: 30px;
    &.issuing-button {
      width: auto;
      font-size: 12px;
      padding: 5px 5px;
    }
  }
`;

export const ButtonInner = styled.div`
  display: flex;
  align-items: center;
  .qmt-ui-loader-animated {
    width: 24px;
    height: 24px;
    margin-left: 8px;
  }
`;

export const ContentControlsRow = styled.div<{ paddingTop?: string }>`
  display: flex;
  justify-content: flex-end;
  padding-top: ${({ paddingTop }) => paddingTop};
  padding-bottom: 64px;
  gap: 16px;
`;

export const OffersContentControlsRow = styled(ContentControlsRow)`
  padding-bottom: 0;
`;

export const IconDefault = styled(DefaultIcon)`
  width: 24px;
  height: 24px;
  margin-left: 8px;
  flex-shrink: 0;
`;

export const IconNextStep = styled(IconDefault)`
  stroke: ${({ theme }) => theme.colors.white};
  transform: rotate(180deg);
`;

export const IssuingIconNextStep = styled(IconNextStep)`
  @media (max-width: ${SMALL_SCREEN_WIDTH}) {
    width: 16px;
    height: 16px;
  }
`;

export const IconNextStepDark = styled(IconNextStep)`
  stroke: ${({ theme }) => theme.colors.black};
`;

export const IssuingIconNextStepDark = styled(IssuingIconNextStep)`
  stroke: ${({ theme }) => theme.colors.black};
`;

// A status, not an action: keeps the issuing button's size, colors come from the (broker) theme
export const CalculationOnlyButton = styled(IssuingButton)`
  &&, &&:hover, &&:disabled {
    opacity: 1;
    cursor: default;
    background-color: ${({ theme }) => theme.colors.buttonPreset.secondary.hover};
    color: ${({ theme }) => `color-mix(in srgb, ${theme.colors.text} 70%, #fff)`};
    white-space: nowrap;
  }

  // The label is a bit longer than "Issue policy" — grow instead of wrapping
  &&.issuing-button {
    width: auto;
    min-width: 148px;
  }
`;

export const CalculationOnlyIcon = styled(IconDefault)`
  width: 20px;
  height: 20px;
  // The sprite icon has black strokes baked in — fade it like the button text
  opacity: 0.7;

  @media (max-width: ${SMALL_SCREEN_WIDTH}) {
    width: 16px;
    height: 16px;
  }
`;

export const QuoteRowWrapper = styled(QuoteRow)`
  grid-template-columns: minmax(60%, auto) 200px;

  // No issuing button rendered — let the row content take the button column too
  & > :only-child {
    grid-column: 1 / -1;
  }

  @media (max-width: ${SMALL_SCREEN_WIDTH}) {
    padding-left: 10px;
    padding-right: 10px;
  }

  // The premium is rendered without a title, so its column is the only one in its price row —
  // that is what separates it from the installment rows, which keep their small titled layout.
  div:only-child > .qmt-ui-quote-row__price-sum,
  div:only-child > .qmt-ui-quote-row__price-label {
    font-family: ${({ theme }) => theme.font.bold};
    font-size: 26px;
  }

  // The 2px the lib puts between amount and currency is tuned for the smaller default size.
  div:only-child > .qmt-ui-quote-row__price-sum {
    margin-right: 6px;
  }
`;
